import resourceService from './resource_service';

const modelName = 'role';

const attributes = {
  name: '',
};

const relationships = {
  userRoles: {
    jsonApi: 'hasMany',
  },
};

export default resourceService(modelName, attributes, relationships);
